import React, { useState } from 'react';
import facebook from "../../assets/img/facebook_icon.svg";
import instagram from "../../assets/img/instagram_icon.svg";
import linkedin from "../../assets/img/linkedin_icon.png";

const Footer = () => {
    const [openAccordion, setOpenAccordion] = useState(null);

    const toggleAccordion = (index) => {
        if (openAccordion === index) {
            setOpenAccordion(null);
        } else {
            setOpenAccordion(index);
        }
    };

    return (
        <footer>
            <div className="wave gray footer"></div>
            <div className="container margin_60_40 fix_mobile">
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <h3 onClick={() => toggleAccordion(1)} className={openAccordion === 1 ? 'opened' : 'collapsed'}>Quick Links</h3>
                        <div className={`collapse dont-collapse-sm links ${openAccordion === 1 ? 'show' : ''}`} id="collapse_1">
                            <ul>
                                <li><a href="https://www.yfs-logistics.com/">Home</a></li>
                                <li><a href="https://tracking.yfsdelivery.com/privacy-policy">Privacy policy</a></li>
                                {/* <li><a href="https://www.yfs-logistics.com/">Terms and conditions</a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <h3 onClick={() => toggleAccordion(2)} className={openAccordion === 2 ? 'opened' : 'collapsed'}>Contacts</h3>
                        <div className={`collapse dont-collapse-sm contacts ${openAccordion === 2 ? 'show' : ''}`} id="collapse_2">
                            <ul>
                                <li><i className="icon_house_alt"></i>Ground floor, building No. 7 G, Al Morshedy, Lasilky station,<br/> New Maadi, El Basatin
Cairo, Egypt</li>
                                <li><i className="icon_chat_alt"></i><a href="tel:+201150618967">+201150618967</a></li>
                                <li><i className="icon_chat_alt"></i><a href="tel:+201011641577">+201011641577</a></li>
                                <li><i className="icon_mail_alt"></i><a href="mailto:customer.service@yallafelsekka.com">customer.service@yallafelsekka.com</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <h3 onClick={() => toggleAccordion(3)} className={openAccordion === 3 ? 'opened' : 'collapsed'}>Follow Us</h3>
                        <div className={`collapse dont-collapse-sm ${openAccordion === 3 ? 'show' : ''}`} id="collapse_3">
                            <div className="follow_us">
                                <ul>
                                    <li><a href="https://www.facebook.com/YFSdelivery?mibextid=LQQJ4d"><img src={facebook} alt="YFS" /></a></li>
                                    <li><a href="https://www.instagram.com/yallafelsekka/"><img src={instagram} alt="YFS" /></a></li>
                                    <li><a href="https://www.linkedin.com/company/yalla-fel-sekka/"><img src={linkedin} alt="YFS" style={{ width: "100%", height: "41px" }} /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-lg-6">
                    </div>
                    <div className="col-lg-6">
                        <ul className="additional_links">
                            <li><span>© Yallafelsekka</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer